import React, { FC } from 'react';
import { Button } from '@src/components/Button';
import {
  CustomerPlanEnum,
  CustomerSubscriptionCycleEnum,
  CustomerSubscriptionPlanInfoType,
} from '@src/graphql/generated';
import { sendNewIntercomMessage } from '@src/intercom';
import { SubscriptionPlan as Plan } from '../SubscriptionPlan';
import { PlanFeaturesValue } from './interfaces/planFeaturesValue.interface';
import { SubscriptionPlansProps } from './props';
import './styles.scss';

export const SubscriptionPlans: FC<SubscriptionPlansProps> = ({
  onPlanSelect,
  activePlan,
  symbol,
  subscriptionPlans,
  recruiterName,
  onConfirmSubscription,
  hasActiveCard,
  isActivateSubscriptionLoading,
}) => {
  const getPlanFeatures = (subscriptionPlan: CustomerSubscriptionPlanInfoType): PlanFeaturesValue => {
    const monthlyVariant = subscriptionPlan.variants.find(({ cycle }) => {
      return cycle === CustomerSubscriptionCycleEnum.MONTHLY;
    });

    if (subscriptionPlan.planType === CustomerPlanEnum.SUBSCRIPTION_LIMITED_LOW_BASE && monthlyVariant) {
      return {
        features: [
          'Get access to daily Open Applicants  list',
          'Full access to Open Applicants history',
          'Message talents within MeetFrank',
          "Search 20'000+ Open Applicants who are open for headhunting",
          'Target and reach 250’000+ talents',
          <span>
            Includes one opening (
            <strong>
              {symbol}
              {monthlyVariant.openingActivationPrice}
            </strong>{' '}
            per each additional opening per month)
          </span>,
        ],
        subTitle: 'For startups and small companies.',
      };
    } else if (subscriptionPlan.planType === CustomerPlanEnum.SUBSCRIPTION_LIMITED_HIGH_BASE && monthlyVariant) {
      return {
        features: [
          'Get access to daily Open Applicants list',
          'Full access to Open Applicants history',
          'Message talents within MeetFrank',
          "Search 20'000+ Open Applicants who are open for headhunting",
          'Target and reach 250’000+ talents',
          <span>
            Includes one opening (
            <strong>
              {symbol}
              {monthlyVariant.openingActivationPrice}
            </strong>{' '}
            per each additional opening per month)
          </span>,
        ],
        subTitle: 'For scaleups and large companies.',
      };
    } else {
      return { features: [] };
    }
  };

  return (
    <div className="subscription-plans">
      <div className="subscription-plans__header-content">
        <h5>Welcome to MeetFrank, {recruiterName}!</h5>
        <h2>Subscribe for full access</h2>
        <p>
          You&apos;re currently using MeetFrank for free. Activate your subscription and
          <br />
          get full access to all talent on the MeetFrank platform and more.
        </p>
      </div>

      <div className="subscription-plans__cards">
        {/* <Plan
          currency={symbol}
          features={['Get access to daily Open Applicants list', 'Message Open Applicants directly']}
          isDisabled={true}
          period={CustomerSubscriptionCycleEnum.MONTHLY}
          price={0}
          subTitle="Checking MeetFrank for daily updates."
          title="Free"
        /> */}
        {subscriptionPlans &&
          subscriptionPlans.map(plan => {
            const content = getPlanFeatures(plan);
            const monthlyVariant = plan.variants.find(({ cycle }) => {
              return cycle === CustomerSubscriptionCycleEnum.MONTHLY;
            });

            const isSelected = activePlan === plan.planType;

            if (plan.planType === CustomerPlanEnum.SUBSCRIPTION_UNLIMITED) {
              return null;
            }

            return (
              <Plan
                currency={symbol}
                features={content.features}
                isSelected={isSelected}
                key={plan.planType}
                onClick={() => onPlanSelect(plan.planType)}
                period={CustomerSubscriptionCycleEnum.MONTHLY}
                price={monthlyVariant?.price}
                subTitle={content?.subTitle}
                title={plan.name}
              />
            );
          })}
      </div>

      <div className="subscription-plans__action-wrapper">
        <Button
          className="subscription-plans__confirm"
          isDisabled={isActivateSubscriptionLoading}
          onClick={onConfirmSubscription}
        >
          {hasActiveCard ? 'Confirm my subscription' : 'Continue'}
        </Button>

        <div className="subscription-plans__unlimited-plan">
          Looking for an unlimited Enterprise plan?{' '}
          <span onClick={() => sendNewIntercomMessage("Hi! I'm interested in the UNLIMITED subscription plan.")}>
            Contact us
          </span>
          .
        </div>
      </div>
    </div>
  );
};
